import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/core/services';
import { User } from '@app/core/models';
import { environment } from '@environments/environment';


@Component({ 
    templateUrl: 'login.component.html',
    // styles: [``]
})
export class LoginComponent implements OnInit {
    
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    currentUser: User;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) { 
        // redirect to home if already logged in
        // if (this.authService.currentUserValue) { 
        //     //this.router.navigate(['/']);
        // }
        this.authService.currentUser.subscribe(x => { 
            this.currentUser = x;
        });
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    get isAdmin() {

        return this.currentUser// && this.currentUser.role === Role.Admin;
    
    }

    protected reset() {

        this.loading = false;
        this.error = '';
        this.loginForm.patchValue({
            password: ''
        });
    
    }
    
    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authService.login(this.f.username.value, this.f.password.value)
            // .pipe(this.res.data)
            .subscribe(
                user => {
                    if(user) {
                        this.currentUser = user;
                        this.reset();
                        this.router.navigate([this.returnUrl]); 
                    }
                    else {
                        this.error = 'No existe el usuario ó la contraseña es incorrecta.';
                        this.loading = false;
                    }
                },
                error => {
                    this.error = error;
                    this.loading = false;
                }
                // (res) => {
                // // super.next(x)
                // console.log(res);              
                // // if(callback)
                // //     callback(table, res);
                // // },
                // // (fail) => {        
                // // console.log("Error", fail);
                // // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
                // }
            ); 
            // .pipe(first())
            // .subscribe(
            //     data => {
            //         this.router.navigate([this.returnUrl]);
            //     },
            //     error => {
            //         this.error = error;
            //         this.loading = false;
            //     });
    }

}